module.exports = __webpack_public_path__ + "img/apotheke-am-ldw.a01f217f.jpg";